export default {
  id: {
    type: Number,
    visibility: false,
  },
  name: {
    label: 'Nombre',
    type: String,
  },
  uniqueId: {
    label: 'Identificador',
    type: String,
  },
  servidor: {
    label: 'Servidor',
    type: String,
    options: [
      { id: 'legacy', name: 'Websocket' },
      { id: 'hls', name: 'hls' },
    ],
  },
  city: {
    label: 'Municipio',
    type: String,
  },
  address: {
    label: 'Dirección',
    type: String,
    textarea: true,
  },
  _location: {
    label: 'Ubicación',
    type: String,
    location: true,
    fields: ['latitude', 'longitude'],
  },
  longitude: {
    label: 'Longitud',
    type: Number,
    visibility: false,
  },
  latitude: {
    label: 'Latitud',
    type: Number,
    visibility: false,
  },
  contact: {
    label: 'Contacto',
    type: String,
  },
  groupId: {
    label: 'Grupo',
    type: Number,
    optional: true,
    model: 'groups',
    module: 'cameras',
    autocomplete: false,
  },
  disabled: {
    label: 'Deshabilitado',
    type: Boolean,
    optional: true,
  },
  attributes: {
    label: 'Camaras',
    type: Array,
    title: (item) => {
      return item.name;
    },
    onChange: (val, field) => {
      field.attributes.value.forEach((attr, i) => {
        attr.name = 'dev' + i;
      });
    },
    optional: true,
  },
  'attributes.$': {
    type: {
      server: {
        label: 'Servidor',
        type: String,
        model: 'v2/video-servers',
        autocomplete: false,
      },
      name: {
        label: 'Nombre',
        type: String,
        visibility: false,
      },
      ip: {
        label: 'Dirección IP',
        type: String,
      },
      user: {
        label: 'Usuario',
        type: String,
      },
      password: {
        label: 'Password',
        type: String,
      },
      stream: {
        label: 'Stream',
        type: String,
      },
      isPtz: {
        label: 'Es PTZ',
        type: Boolean,
      },
    },
  },
};
